module.exports = __webpack_public_path__ + "static/media/image_38.45f4fb70.png";